import { connect } from 'react-redux';
import { authenticate as _authenticate, changePassword as _changePassword, checkEmail as _checkEmail } from '../../../../actions/authentication';
import { changeFlow as _changeFlow } from '../../../../actions/flow';
import { changeLogin as _changeLogin } from '../../../../actions/login';
import { professionalUserChange, register as _register } from '../../../../actions/registration';
import { resetToPhoneAuth as _resetToPhoneAuth, changeToPhoneAuth as _changeToPhoneAuth } from '../../../../actions/state';
import { changeView as _changeView } from '../../../../actions/view';
import { flowSelector, hasLoginErrorSelector, hasPasswordErrorSelector, hasPhoneErrorSelector, isFormSubmitting, isLoginInvalidSelector, isPasswordInvalidSelector, isProfessionalUserSelector, loginErrorSelector, loginSelector, passwordErrorSelector, passwordSelector, phoneErrorSelector, submitButtonTextSelector } from './selectors';
import { selectAutoFocusDisabled } from '../../../../selectors/autoFocusDisabled';
import { UsernameAuthFormContainer as Component } from './UsernameAuthFormContainer';
import { sourceSelector } from '../../../../selectors/source';
function mapStateToProps(state) {
  return {
    isSubmitting: isFormSubmitting(state),
    activeFlow: flowSelector(state),
    submitButtonText: submitButtonTextSelector(state),
    login: loginSelector(state),
    loginError: loginErrorSelector(state),
    isLoginInvalid: isLoginInvalidSelector(state),
    hasAsyncLoginError: hasLoginErrorSelector(state),
    password: passwordSelector(state),
    passwordError: passwordErrorSelector(state),
    isPasswordInvalid: isPasswordInvalidSelector(state),
    hasAsyncPasswordError: hasPasswordErrorSelector(state),
    hasAsyncPhoneError: hasPhoneErrorSelector(state),
    phoneError: phoneErrorSelector(state),
    autoFocusDisabled: selectAutoFocusDisabled(state),
    isProfessionalUser: isProfessionalUserSelector(state),
    source: sourceSelector(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeLogin: function changeLogin(login) {
      dispatch(_changeLogin(login));
    },
    changePassword: function changePassword(password) {
      dispatch(_changePassword(password));
    },
    authenticate: function authenticate(params) {
      dispatch(_authenticate(params));
    },
    register: function register(params) {
      dispatch(_register(params));
    },
    checkEmail: function checkEmail() {
      dispatch(_checkEmail());
    },
    changeView: function changeView(view, data) {
      dispatch(_changeView(view, data));
    },
    changeFlow: function changeFlow(flow) {
      dispatch(_changeFlow(flow));
    },
    resetToPhoneAuth: function resetToPhoneAuth() {
      dispatch(_resetToPhoneAuth());
    },
    changeToPhoneAuth: function changeToPhoneAuth(phone) {
      dispatch(_changeToPhoneAuth(phone));
    },
    changeIsProfessionalUser: function changeIsProfessionalUser(value) {
      dispatch(professionalUserChange(value));
    }
  };
}
export var FormContainer = connect(mapStateToProps, mapDispatchToProps)(Component);